export default defineNuxtRouteMiddleware(() => {
  const { showSnackbar } = useSnackbarStore();
  const { $i18n } = useNuxtApp();
  const { t } = $i18n;
  const partner = localStorage.getItem('partnerName');

  if (!checkPermission('manageOperations')) {
    showSnackbar({
      type: 'error',
      message: t('common.forbiddenAccess')
    });

    return navigateTo({
      name: 'partner-home',
      params: { partner }
    });
  }
});
